module.exports = {"name":"Mohamed Albgal","links":"skills,projects"}